module.exports = __webpack_public_path__ + "media/images/official/guide_ttl-a97de21a284a420da956c56f46b05e26.svg";